module.exports = __webpack_public_path__ + "static/media/upcomingEvents_1.de5377db.jpg";